import React from 'react';

import { Box, InputAdornment, Stack } from '@mui/material';

import styled from '@emotion/styled';
import { useField } from 'formik';

import { CurrencySign } from '../../../../../components/CurrencySign/CurrencySign';
import FormikNumberField from '../../../../../components/Formiks/NumberField/NumberField';
import FormikTextField from '../../../../../components/Formiks/TextField/TextField';
import { OfferCategory } from '../../../../../graphql/API';
import { useAppSelector } from '../../../../../redux/hooks';
import { Method } from '../../../ProductForm';
import SideBySide from '../../SideBySide';
import OfferPhoto from '../../formiks/OfferPhoto/OfferPhoto';
import { FormValue, StepOneFormValue } from '../../schema';

type Values = StepOneFormValue;

type Props = {
  method?: Method;
  initialValues?: Values;
  values: Values;
  handlePersistFormDataStep?: (values: Partial<FormValue>) => void;
  isShopifyProduct?: boolean;
};

export const Form1: React.FC<Props> = ({
  values,
  handlePersistFormDataStep,
  isShopifyProduct = false,
}) => {
  const venueState = useAppSelector((state) => state.venue.value);

  const [titleField, , titleFieldHelper] = useField('title');

  React.useEffect(() => {
    // const formattedValue = titleField.value.charAt(0).toUpperCase() + titleField.value.slice(1);
    // titleFieldHelper.setValue(formattedValue);
  }, [titleField.value, titleFieldHelper]);

  React.useEffect(() => {
    if (handlePersistFormDataStep) handlePersistFormDataStep({ ...(values as FormValue) });
  }, [values]);

  return (
    <Box>
      <Stack spacing={6} sx={{ width: '100%' }}>
        <OfferPhoto isShopifyProduct={isShopifyProduct} />
        <CustomBox>
          <Label htmlFor='txt-title' className='offer-form-label'>
            Product title
          </Label>
          <FormikTextField
            id='txt-title'
            name='title'
            placeholder={
              values.category === OfferCategory.event
                ? 'Ex. Fashion week launch event'
                : 'Ex. dinner, haircut and brushing'
            }
            className='offer-input-field'
          />
        </CustomBox>
        <CustomBox>
          <Label htmlFor='txt-desc' className='offer-form-label'>
            Description
          </Label>
          <FormikTextField
            id='txt-desc'
            name='description'
            placeholder={
              values.category === OfferCategory.event
                ? 'Ex. Join us at the exclusive Fashion Week launch event for our brand. There will be a DJ, open bar, and lots of surprises!'
                : 'Ex. 1 lunch item from the menu and drink of choice'
            }
            multiline
            rows={5}
            className='offer-input-field'
          />
        </CustomBox>

        <SideBySide shouldFlexEnd>
          <CustomBox>
            <Label htmlFor='txt-offer-value' className='offer-form-label' style={{ paddingBottom: '0' }}>
              Product value
            </Label>
            <Subtitle>Estimated retail value of the product or service</Subtitle>
            <FormikNumberField
              id='txt-offer-value'
              name='offerValue'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <CurrencySign currency={venueState?.currency || 'usd'} />
                  </InputAdornment>
                ),
              }}
              className='offer-input-field'
            />
          </CustomBox>
        </SideBySide>
      </Stack>
    </Box>
  );
};

const CustomBox = styled.div`
  display: flex;
  flex-direction: column;
  fieldset {
    border: 1px solid #e6e6e6;
  }
`;

const Label = styled.label`
  color: #000;
  font-size: 15px;
  font-weight: 500;
  padding-bottom: 8px;
`;

const Subtitle = styled.div`
  font-family: 'Poppins', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0%;
  color: rgba(17, 17, 17, 0.8);
  padding-bottom: 8px;
  white-space: nowrap;
`;
